import { Component, OnInit } from '@angular/core';
import { OperatorService } from '../services/operator.service';
import { Notification } from '../../account/models/Notification';
import { Page } from 'src/app/shared/model/page';
import { NotificationFilterForm } from '../../anre/notifications-anre/models/NotificationFilterForm';

@Component({
  selector: 'app-notificari-operator',
  templateUrl: './notifications-operator.component.html',
  styleUrls: ['./notifications-operator.component.scss']
})
export class NotificationsOperatorComponent implements OnInit {

  public notifications: Page<Notification>;
  public paginationNotifications = [];
  public notificationFilterForm: NotificationFilterForm = new NotificationFilterForm();
  public notificationDisplaySettings = {
    filter: false,
    actions: {
      custom: [
        {
          name: 'markRead',
          title: '<p class="p_mark_read">Marchează citit</p>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    hideSubHeader: true,
    columns: {
      authorName: {
        title: 'Nume de cod emițător'
      },
      description: {
        title: 'Descriere mesaj'
      },
      // author: {
      //   title: 'Emițător mesaj',
      //   valuePrepareFunction: (author) => { return author?.name; }
      // },
      // correlation: {
      //   title: 'Corelație',
      //   valuePrepareFunction: (correlation) => { return correlation?.name; }
      // },
      // message: {
      //   title: 'Mesaj',
      //   valuePrepareFunction: (message) => { return message?.name; }
      // },
      date: {
        title: 'Data',
        valuePrepareFunction: (value) => { return value ? new Date(value).toLocaleDateString('ro-RO') : '' }
      },
      read: {
        title: 'Status',
        valuePrepareFunction: (value) => { return value ? 'Citită' : 'Necitită' }
      }
    },
    rowClassFunction: (row) => {
      if (!row.data.read) {
        return 'read_color';
      } else {
        return 'mark_read';
      }
    },
  };

  constructor(
    private operatorService: OperatorService
  ) { }

  ngOnInit(): void {
    this.searchNotifications();
  }

  searchNotifications(): void {
    this.operatorService.getOperatorNotifications(this.notificationFilterForm).subscribe((val) => {
      this.notifications = val;
      this.notificationFilterForm.pageOffset = val.number;
      this.paginationNotifications = [{ pageNumber: val.number, className: 'page-item active' }];
      // for (let i = 1; i < val.totalPages; i++) {
      //   this.paginationNotifications.push({ pageNumber: i, className: 'page-item' });
      // }
      // this.paginationNotifications[this.notificationFilterForm.pageOffset].className = 'page-item active';
    });
  }

  changePage(page: any): void {
    this.notificationFilterForm.pageOffset = page.pageNumber;
    this.searchNotifications();
  }

  previousPage(): void {
    this.notificationFilterForm.pageOffset = this.notificationFilterForm.pageOffset === 0 ? 0 : this.notificationFilterForm.pageOffset - 1;
    this.searchNotifications();
  }

  nextPage(): void {
    this.notificationFilterForm.pageOffset = this.notificationFilterForm.pageOffset === this.notifications.totalPages - 1
      ? this.notificationFilterForm.pageOffset : this.notificationFilterForm.pageOffset + 1;
    this.searchNotifications();
  }

  onCustomActionNotifications(event: any): void {
    console.log(event);
    switch (event.action) {
      case 'markRead':
        event.data.read = true;
        this.operatorService.updateNotificationRead(event.data).subscribe(() => this.ngOnInit());
        break;
    }
  }

}
